export const legalTerms = "https://fairgate.ch/agb-standard/";
export const dprTerms = "https://fairgate.ch/datenschutzerklarung/";
export const googleMap = "https://www.google.com/maps?q=";
export const googleMapAPIURL = (apiKey: string) =>
  `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
